/* jshint esversion: 6 */


const selector = '.Ge-Guide';
const guide = function (el, app) {

    const $el = $(el);

    const $questions = $el.find("[data-js-guide-questions]");
    const rules = window[$el.attr("data-js-guide-rules")];

    const init = function () {

        $questions.on("change", function (ev) {
            updateResult();
        });
        $questions.on("reopen", function (ev) {
            hideResults();
        });
    };

    const questionsInterface = function () {
        return $questions[0].interface;
    };

    const hideResults = function () {
        $el.find("[data-js-guide-result]")
            .addClass("Ge-Hidden")
            .removeClass("Ge-Guide-Result--active");
    }
    const updateResult = function () {

        const userAnswers = questionsInterface().getValue();

        const questions = questionsInterface().getQuestions();

        hideResults();
        //if (userAnswers.length === questions.length) {

            const result = evalRules(rules, userAnswers, userAnswers.length === questions.length);

            if (result) {

                const $result = $el.find("[data-js-guide-result-id=" + result + "]");
                $result.removeClass("Ge-Hidden");
                setTimeout(function () {
                     $result.addClass("Ge-Guide-Result--active");
                }, 0);

            }
        // }

    };

    const evalRules = function (rules, userAnswers, allAnswered ) {

        if (!rules) {
            return undefined;
        }

        for (var r = 0; r < rules.length; r++) {

            const result = evalRule(rules[r], userAnswers, allAnswered );

            if (result) {
                return result;
            }
        }
    }

    const evalRule = function (rule, userAnswers, allAnswered ) {

        if( !allAnswered && !rule.alwaysEval ){
            return undefined;
        }

        for (var qr = 0; qr < rule.questionRules.length; qr++) {

            var qRule = rule.questionRules[qr];
            // console.log("eval rule - looking at rule");
            // console.dir(qRule);


            let correctAnswer = false;
            for (var ua = 0; ua < userAnswers.length; ua++) {

                var userAnswer = userAnswers[ua];

                // console.log("eval rule - userAnswer");
                // console.dir(userAnswer);

                if (qRule.question === userAnswer.question) {
                    // console.log("eval rule - match q");
                    correctAnswer = !qRule.answers || qRule.answers.indexOf(userAnswer.answer) !== -1;
                    break;
                }
            }

            // console.log("eval rule - correct answer: " + correctAnswer);

            if (!correctAnswer) {
                return undefined;
            }
        }

        const subResult = evalRules(rule.subRules, userAnswers, allAnswered );
        return subResult ? subResult : rule.result;
    };

    const getItemById = function (items, id) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.id === id) {
                return item;
            }
        }
    }

    return {
        init: init()
    };
};

guide.selector = selector;

export default guide;
